module.exports = __webpack_public_path__ + "img/ht.c0cb323c.svg";